import React from "react";

export default function WazeSVGIcon() {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        // fill="#000000"
        fill="#fff"
        stroke="none"
      >
        <path
          d="M2645 4949 c-279 -27 -571 -112 -825 -241 -622 -317 -1037 -866
-1150 -1523 -19 -109 -23 -172 -25 -395 -2 -237 -4 -274 -24 -345 -61 -225
-174 -332 -376 -356 -149 -18 -154 -19 -190 -50 -46 -41 -59 -85 -52 -180 9
-112 23 -162 78 -274 121 -249 387 -435 807 -565 56 -17 102 -32 102 -33 0 -1
-7 -34 -15 -72 -29 -140 -12 -265 57 -404 103 -210 332 -351 568 -351 236 0
465 141 568 351 44 88 72 192 72 268 0 33 3 42 14 38 8 -3 152 -9 320 -13
l306 -7 0 -31 c1 -64 31 -172 72 -255 103 -210 332 -351 568 -351 459 0 773
485 581 897 l-30 63 97 64 c378 249 659 592 822 1002 74 184 130 484 130 687
-2 922 -641 1724 -1591 1996 -276 79 -591 108 -884 80z m540 -333 c754 -115
1354 -614 1550 -1291 45 -155 59 -259 59 -450 0 -181 -11 -272 -51 -415 -121
-436 -419 -818 -822 -1055 -79 -46 -85 -48 -115 -35 -135 56 -169 64 -286 64
-97 0 -127 -5 -196 -27 -130 -43 -248 -131 -326 -245 l-31 -45 -271 6 c-149 4
-335 10 -413 14 l-142 6 -46 58 c-121 154 -332 249 -526 236 -135 -9 -290 -69
-370 -143 l-25 -24 -122 35 c-300 85 -479 179 -605 315 -52 56 -97 125 -97
148 0 5 33 19 74 30 196 57 339 181 435 377 89 181 113 326 109 655 -3 241 7
324 57 495 111 382 356 719 693 953 299 207 611 317 1017 356 78 8 352 -4 450
-18z"
        />
        <path
          d="M2170 3497 c-59 -31 -82 -76 -78 -147 5 -67 27 -102 84 -130 50 -25
87 -25 140 -1 55 25 86 77 86 141 0 64 -31 116 -86 141 -55 25 -94 24 -146 -4z"
        />
        <path
          d="M3444 3495 c-54 -32 -78 -81 -72 -150 2 -29 13 -63 24 -78 23 -33 90
-67 130 -67 48 1 109 34 134 74 49 80 18 190 -64 227 -56 25 -103 24 -152 -6z"
        />
        <path
          d="M2015 2704 c-44 -23 -66 -45 -81 -81 -20 -46 -17 -81 12 -175 103
-328 363 -572 699 -659 129 -34 341 -34 470 0 282 73 513 258 643 516 36 73
82 215 82 256 0 98 -95 173 -195 155 -61 -12 -101 -57 -130 -147 -77 -244
-236 -402 -467 -465 -85 -24 -251 -24 -337 0 -225 61 -393 226 -463 454 -11
37 -31 82 -45 101 -44 57 -126 77 -188 45z"
        />
      </g>
    </svg>
  );
}
